import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { suiteTabs } from '../../data/homeContent';

function HomeSuite() {
  const [active, setActive] = useState(suiteTabs[0].id);
  const tab = suiteTabs.find((item) => item.id === active) || suiteTabs[0];

  return (
    <section className="home-section home-suite" id="suite">
      <div className="container">
        <div className="home-section-head">
          <p className="home-kicker">COMPLETE SCHOOL MANAGEMENT SUITE</p>
          <h2>School management software for admissions, academics, finance, and campus ops</h2>
          <p className="home-lead">
            A unified platform for ERP, LMS, website, AI, and leadership analytics — so teams are not stitching five tools together.
          </p>
        </div>

        <div className="home-tabs home-tabs-bar" role="tablist">
          {suiteTabs.map((item) => (
            <button
              key={item.id}
              type="button"
              className={item.id === active ? 'is-active' : ''}
              onClick={() => setActive(item.id)}
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="home-card-grid home-suite-grid">
          {tab.items.map((item, index) => (
            <article key={item.title} className={`home-card home-card-lite home-card-tone-${(index % 4) + 1}`}>
              <span className="home-card-index">0{index + 1}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>

        <div className="home-center-action">
          <Link to="/platforms" className="home-btn home-btn-primary">
            View platforms
          </Link>
        </div>
      </div>
    </section>
  );
}

export default HomeSuite;
